import clientAuth from "../clientAuth";

export default {
  index: () => clientAuth.get("outdoor/index"),
  
  store: (userData) => clientAuth.post('outdoor/store', { json: userData }),
  

  show:(id)=>clientAuth.get('outdoor/show/'+id),

  update:(id,userData)=>clientAuth.post('outdoor/update/'+id,{json:userData}),

  destroy:(id)=>clientAuth.delete(`outdoor/destroy/${id}`),
};